import React from "react";

interface AggregateTypeElementFieldProps {
  title: string;
  handleClick: () => void;
  className?: string;
}

export const AggregateTypeElementField = ({
  title,
  handleClick,
  className,
}: AggregateTypeElementFieldProps) => {
  return (
    <li>
      <button type="button" onClick={handleClick} className={className}>{title}</button>
    </li>
  );
};
